import type { SummarizeData } from '@brighterly/lib-core-types/ai-summarize/interfaces'

import { useAiSummarizeStore } from '@stores/ai-summarize'

import { useAppBrand } from '@composables/tools/app-brand.hook'
import { useAiSummaryApi } from '@api/ai-summary/ai-summary.hook'

import { defineNuxtRouteMiddleware, navigateTo } from '#app'

export default defineNuxtRouteMiddleware(async (to) => {
  const { isSmartestMinds } = useAppBrand()

  if (isSmartestMinds) return navigateTo('/')

  const aiSummarizeStore = useAiSummarizeStore()

  useAiSummaryApi({
    params: to.params,
  }, {
    onStart: () => aiSummarizeStore.setLoading(true),
    onSuccess: (data: SummarizeData) => {
      const bookingId = Number(to.params.summarize)
      aiSummarizeStore.setBookingId(bookingId)
      aiSummarizeStore.setSummaryId(data.id)
      aiSummarizeStore.setDuration(data.duration)
      aiSummarizeStore.setLessonDate(data.lesson_date)
      aiSummarizeStore.setSpeakingTime(data.speaking_time)
      aiSummarizeStore.setTopic(data.topic)
      aiSummarizeStore.setTitle(data.title)
      aiSummarizeStore.setRecordingUrl(data.recording_url)
      aiSummarizeStore.setSummary(data.summary)
      aiSummarizeStore.setHomeTasks(data.home_tasks || [])
      aiSummarizeStore.setHomeActivities(data.home_activities || [])
      aiSummarizeStore.setHighlights(data.highlights || [])
      if (data.survey) {
        aiSummarizeStore.setSurvey(true)
        const answer = data.survey.answers[0]?.answer as number | null
        aiSummarizeStore.setRating(answer || 0)
        aiSummarizeStore.setComment(data.survey.answers[0]?.comment || null)
      }
    },
    onError: () => aiSummarizeStore.setLoading(false),
    onFinish: () => aiSummarizeStore.setLoading(false),
  })
})
